import { Command, DateCreatedData } from '../interfaces';

export enum NEWEST_SORT {
    NEWEST = 'NEWEST',
}

/**
 * Sort based on the date created. I.e. 2020-02-19T14:46:59+00:00 is converted to a numeric timestamp.
 * @param data a treatment
 * @returns DateCreatedData[]
 */
export const newestSort = <T extends DateCreatedData>(data: T[], keys: keyof typeof NEWEST_SORT) => {
    let result: DateCreatedData[] = [];
    if (keys === NEWEST_SORT.NEWEST) {
        result = data.sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime());
    }
    return result;
};

export class NewestSortCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: DateCreatedData[], keys: keyof typeof NEWEST_SORT) {
        return newestSort(data, NEWEST_SORT[keys]);
    }
}
